<template>
  <b-modal id="bank-modal" ref="modal" @show="onShow" centered hide-footer hide-header>
    <div class="header">
      <span>{{ $t('BANK_ACCOUNT_INFOMATION_INPUT') }}</span>
    </div>
    <b-container>
      <b-row>
        <b-col lg="6" md="12">
          <text-input
            v-model="bankAccountName"
            ref="bankAccountNameInput"
            :label="$t('FULL_NAME')"
            dynamic-label
            required
          />
        </b-col>
        <b-col lg="6" md="12">
          <text-input
            v-model="bankName"
            ref="bankNameInput"
            :label="$t('BANK_NAME')"
            dynamic-label
            required
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6" md="12">
          <text-input
            v-model="bankAccountNo"
            ref="bankAccountNoInput"
            :label="$t('ACCOUNT_NUMBER')"
            dynamic-label
            required
          />
        </b-col>
        <b-col lg="6" md="12">
          <text-input
            v-model="bankBranch"
            ref="bankBranchInput"
            :label="$t('BANK_BRANCH')"
            dynamic-label
          />
        </b-col>
      </b-row>
      <div class="btn-footer" v-if="!isMobile">
        <primary-button class="action-button" @click="off" white rounded-corner :text="$t('BACK')" />
        <primary-button class="action-button" @click="() => checkEdit? updateBankAccount(bankAccount.id) : add()" :disabled="disabled" rounded-corner :text="$t('CONFIRM')" />
      </div>
      <div class="btn-footer-mobile" v-else>
        <primary-button @click="off" white :text="$t('BACK')" />
        <primary-button  @click="() => checkEdit? updateBankAccount(bankAccount.id) : add()" :disabled="disabled" :text="$t('CONFIRM')" />
      </div>
    </b-container>
  </b-modal>
</template>

<script>
import { watch, ref, computed } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import PrimaryButton from '@/components/PrimaryButton';
import TextInput from '@/components/TextInput';

import ClientDetailServices from '@/views/ClientDetail/ClientDetailServices';

const { useState, useActions } = createNamespacedHelpers('clientDetail');
const { useActions: useFlashActions } = createNamespacedHelpers('flash');
const { useState: useStateApp } = createNamespacedHelpers('app');


export default {
  name: 'BankAccountModal',
  components: {
    PrimaryButton,
    TextInput,
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    checkEdit: Boolean,

    bankAccount: {
      type: Object,
      default: null,
    }
  },
  setup(props, { root }) {
    const { detail } = useState(['detail']);
    const { getClientBankAccounts } = useActions(['getClientBankAccounts']);
    const { info, error } = useFlashActions(['info', 'error']);

    const { isMobile } = useStateApp(['isMobile']);

    const { id: clientId } = root.$route.params;

    const modal = ref(null);
    const popup = computed(() => props.value);

    const bankAccountName = ref('');
    const bankAccountNameInput = ref(null);
    const bankName = ref('');
    const bankNameInput = ref(null);
    const bankAccountNo = ref('');
    const bankAccountNoInput = ref(null);
    const bankBranch = ref('');

    const onShow = () => {
      if (props.checkEdit) {
        bankName.value = props.bankAccount.bankName;
        bankAccountNo.value = props.bankAccount.bankAccountNo;
        bankBranch.value = props.bankAccount.bankBranch;
      }
      bankAccountName.value = detail.value.fullName;
    };

    const off = () => {
      modal.value.hide();
      bankAccountName.value = '';
      bankName.value = '';
      bankAccountNo.value = '';
      bankBranch.value = '';
    };

    const add = async () => {
      try {
        const data = {
          bankAccountName: bankAccountName.value,
          bankName: bankName.value,
          bankAccountNo: bankAccountNo.value,
          bankBranch: bankBranch.value,
          client: clientId
        };

        await ClientDetailServices.createBankAccount(data);
        getClientBankAccounts(clientId);
        info('CREATED_BANK_ACCOUNT_SUCCESS');
        off();
      } catch(e) {
        error(e);
      }
    };

    const updateBankAccount = async (id) => {
      try {
        const data = {
          bankAccountName: bankAccountName.value,
          bankName: bankName.value,
          bankAccountNo: bankAccountNo.value,
          bankBranch: bankBranch.value,
          client: clientId
        };

        await ClientDetailServices.updateBankAccount(id, data);
        getClientBankAccounts(clientId);
        info('UPDATED_BANK_ACCOUNT_SUCCESS');
        off();
      } catch(e) {
        error(e);
      }
    };

    const disabled = computed(() => bankAccountName.value === '' || bankName.value === '' || bankAccountNo.value === '');

    watch(popup, (value) => {
      if (value) modal.value.show();
      else modal.value.hide();
    });

    return {
      modal,
      bankAccountName,
      bankAccountNameInput,
      bankName,
      bankNameInput,
      bankAccountNo,
      bankAccountNoInput,
      bankBranch,
      onShow,
      off,
      add,
      disabled,
      updateBankAccount,
      isMobile,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

#bank-modal {

  .header {
    text-align: center;
    padding-top: 10px;
    padding-bottom: 20px;
    font-size: 25px;
    font-weight: bold;
  }

  .row {
    padding: 10px 10px;
  }

  .action-button {
    margin: 20px 20px 20px 6px;
  }

  button {
    margin-left: 50px;
    box-shadow: 1px 3px 10px -2px $doveGray;
  }

  .btn-footer {
    text-align: center;
  }

  @media (max-width: 991px) {
    .col-md-12 {
      padding: 7px
    }

    button {
      margin-left: unset !important;
    }

    .btn-footer-mobile {

      .primary-button {
        display: block;
        width: 100%;
        margin-bottom: 15px;
        border-radius: 3px;
      }
    }
  }
}
</style>
